import api from './serviceApi'; // Import the axios instance

const dashboardApi = {
  /**
   * Fetch dashboard metrics.
   * @returns {Promise<Object>} - The metrics data.
   */
  getMetrics: async (params = {}) => {
    try {
      const response = await api.get('/dashboard/metrics', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dashboard metrics:', error);
      throw error;
    }
  }
};

export default dashboardApi;
